/** Arabic for the screens around the table: lobby, home, leaderboard, my data, errors (review 0021). */
export const arScreens: Record<string, string> = {
  "lobby.seated": "{count} / 4 جالسون",
  "lobby.ready": "جاهز",
  "lobby.empty": "مقعد فارغ",
  "lobby.watchers": "{count} يشاهدون",
  "lobby.title": "الردهة",
  "lobby.seat.empty": "اجلس",
  "lobby.seat.bot": "بوت",
  "lobby.seat.away": "غائب",
  "lobby.settings": "{variant} · {target} · {tempo}",
  "lobby.target.goal": "أول من يصل {goal}",
  "lobby.target.length": "{length} {length|one:جولة|two:جولتان|few:جولات|other:جولة}",
  "lobby.target.points": "إلى {goal} نقطة",
  "lobby.fillBots": "املأ بالبوتات",
  "lobby.start": "ابدأ الآن",
  "lobby.countdown": "يبدأ خلال {seconds}",
  "lobby.game": "اللعبة",
  "lobby.share.message": "انضم إلى طاولتي في High Card Club",
  "lobby.leaveTable": "العودة إلى قناتي",
  "tooltip.invite": "ادعُ صديقًا",
  "tooltip.sound": "مستوى الصوت",
  "home.scene": "المكان",
  "home.deck": "الورق",
  "home.title": "اختر لعبة",
  "home.subtitle": "لهذه القناة طاولة واحدة؛ من يفتحها يختار اللعبة.",
  "home.open": "افتح الطاولة",
  "home.goal": "العب حتى",
  "home.hands": "الجولات",
  "home.tempo": "السرعة",
  "home.points": "{goal} نقطة",
  "home.handsCount": "{length} {length|one:جولة|two:جولتان|few:جولات|other:جولة}",
  "home.heading": "الردهة",
  "home.tab.create": "جهّز طاولة",
  "home.tab.join": "انضم إلى طاولة",
  "home.quick": "ابحث عن لاعبين: {game}",
  "home.rules": "قواعد الطاولة",
  "home.who": "من يمكنه الانضمام",
  "home.who.anyone": "الجميع",
  "home.who.invite": "بالدعوة فقط",
  "home.leaderboard": "لوحة الصدارة",
  "scene.orman": "الغابة",
  "scene.otel": "الفندق",
  "scene.uzay": "الفضاء",
  "scene.istanbul": "إسطنبول",
  "scene.majlis": "المجلس",
  "scene.neon": "نيون",
  "deck.classic": "كلاسيك",
  "deck.anime": "أنمي",
  "deck.obsidian": "أوبسيديان",
  "club.badge": "Club",
  "club.new": "جديد",
  "club.trialOffer": "مجانًا لمدة 3 أيام",
  "club.starting": "جارٍ التفعيل…",
  "club.left.days": "مجانًا · بقي {count} {count|one:يوم|two:يومان|few:أيام|other:يوم}",
  "club.left.hours": "مجانًا · بقي {count} {count|one:ساعة|two:ساعتان|few:ساعات|other:ساعة}",
  "club.left.minutes": "مجانًا · بقي {count} دقيقة",
  "club.locked": "يعود مع Club",
  "club.notify": "أخبرني",
  "club.notified": "سنخبرك",
  "club.ended.deck": "انتهت تجربة ورق {name}. يعود مع Club.",
  "club.ended.scene": "انتهت تجربة مكان {name}. يعود مع Club.",
  "invite.copied": "تم نسخ الرابط",
  "invite.copiedSub": "أرسله لصديق ليصل مباشرة إلى الطاولة.",
  "auth.connecting": "جارٍ الاتصال بديسكورد…",
  "auth.denied": "يحتاج High Card Club إذنًا لمعرفة هويتك.",
  "auth.server": "لم يستجب خادم الطاولة.",
  "auth.refresh": "يتوفر إصدار جديد. أعد فتح النشاط.",
  "auth.retry": "حاول مرة أخرى",
  "update.title": "إصدار جديد جاهز",
  "update.body": "أعد التحميل لمتابعة اللعب. إن كنت في مباراة فمقعدك بانتظارك.",
  "update.reload": "إعادة التحميل",
  "profile.loading": "جارٍ تحميل سجلك…",
  "profile.none": "لا توجد مباريات بعد. افتح طاولة.",
  "profile.record":
    "{matches} {matches|one:مباراة|two:مباراتان|few:مباريات|other:مباراة} · {wins} {wins|one:فوز|two:فوزان|few:انتصارات|many:فوزًا|other:فوز}",
  "rule.spades.bagPenalty": "عقوبة الزيادات",
  "rule.spades.bagPenalty.true": "10 زيادات = −100",
  "rule.spades.bagPenalty.false": "بدون عقوبة",
  "rule.tarneeb.trumpLead": "البدء بالطرنيب",
  "rule.tarneeb.trumpLead.false": "في أي وقت",
  "rule.tarneeb.trumpLead.true": "بعد كسره فقط",
  "rule.tarneeb.minBid": "أقل طلب",
  "rule.tarneeb.minBid.7": "7",
  "rule.tarneeb.minBid.5": "5",
  "rule.baloot.projects": "المشاريع",
  "rule.baloot.projects.true": "سرا، 50، 100، 400",
  "rule.baloot.projects.false": "بدون",
  "rule.baloot.doubling": "الدبل",
  "rule.baloot.doubling.true": "الدبل حتى القهوة",
  "rule.baloot.doubling.false": "بدون",
  "tempo.relaxed": "هادئ",
  "tempo.normal": "عادي",
  "tempo.fast": "سريع",
  "data.open": "{name} - بياناتي",
  "data.title": "بياناتي",
  "data.back": "رجوع",
  "data.failed": "لم ينجح ذلك. حاول مرة أخرى بعد قليل.",
  "data.legal": "قانوني",
  "data.leaderboard": "لوحة الصدارة",
  "data.hide": "إخفاء اسمي في لوحة الصدارة",
  "data.hide.about": "تبقى مبارياتك محسوبة. يرى الآخرون «لاعب مخفي» بدل اسمك وصورتك.",
  "data.usage": "قياس الاستخدام",
  "data.measure": "المشاركة في قياس الاستخدام",
  "data.measure.about":
    "نحسب الأيام التي تفتح فيها اللعبة وتجلس إلى الطاولة وتنهي المباريات، ولا شيء غير ذلك. إذا أوقفته تُحذف هذه السجلات ولا يُحفظ جديد.",
  "data.download": "نسخة من بياناتك",
  "data.download.about":
    "يفتح رابط في متصفحك بملف JSON يحوي كل ما نحتفظ به عنك. يعمل مرة واحدة لمدة عشر دقائق.",
  "data.download.start": "تنزيل بياناتي",
  "data.delete": "الحذف",
  "data.delete.about":
    "ننتظر 30 يومًا، ثم تُجهَّل مبارياتك ويُحذف كل ما سواها. يمكنك الإلغاء حتى ذلك الحين.",
  "data.delete.start": "حذف بياناتي",
  "data.delete.confirm":
    "بعد 30 يومًا تبقى مبارياتك لخصومك باسم «لاعب محذوف» فقط، وتُحذف تجاربك وتنبيهات Club وإعداداتك. لا يمكن التراجع بعد ذلك اليوم.",
  "data.delete.yes": "احذف بعد 30 يومًا",
  "data.delete.keep": "احتفظ ببياناتي",
  "data.delete.pending": "ستُحذف بياناتك في {date}.",
  "data.delete.cancel": "إلغاء الحذف",
  "legal.privacy": "سياسة الخصوصية",
  "legal.terms": "شروط الاستخدام",
  "legal.notice": "باللعب فإنك توافق على",
  "legal.dismiss": "إغلاق",
  "error.seat-taken": "تم أخذ هذا المقعد للتو.",
  "error.kicked": "أخرجك صاحب الطاولة. يمكنك متابعة المشاهدة.",
  "error.not-owner": "صاحب الطاولة فقط يمكنه ذلك.",
  "error.not-lobby": "بدأت اللعبة بالفعل.",
  "error.look-locked": "هذا مقفل؛ تبقى الطاولة على الافتراضي.",
  "error.spectators-full": "الطاولة ممتلئة بالمشاهدين.",
  "error.generic": "حدث خطأ ما ({code}).",
  "error.boundary": "حدث عطل من جهتنا. أعد تحميل النشاط.",
  "error.eventId": "رقم الحدث: {id}",
  "error.reload": "إعادة التحميل",
  "leaderboard.hiddenPlayer": "لاعب مخفي",
  "leaderboard.title": "لوحة الصدارة",
  "leaderboard.back": "رجوع",
  "leaderboard.periods": "الفترة",
  "leaderboard.period.week": "الأسبوع",
  "leaderboard.period.month": "الشهر",
  "leaderboard.period.all": "كل الأوقات",
  "leaderboard.heading.week": "الترتيب الأسبوعي",
  "leaderboard.heading.month": "الترتيب الشهري",
  "leaderboard.heading.all": "ترتيب كل الأوقات",
  "leaderboard.left.days":
    "بقي {days} {days|one:يوم|two:يومان|few:أيام|other:يوم} و{hours} {hours|one:ساعة|two:ساعتان|few:ساعات|other:ساعة}",
  "leaderboard.left.hours": "بقي {hours} {hours|one:ساعة|two:ساعتان|few:ساعات|other:ساعة}",
  "leaderboard.left.soon": "بقي أقل من ساعة",
  "leaderboard.record": "{wins}-{losses}",
  "leaderboard.recordName":
    "{wins} {wins|one:فوز|two:فوزان|few:انتصارات|many:فوزًا|other:فوز}، {losses} {losses|one:خسارة|two:خسارتان|few:خسارات|other:خسارة}",
  "leaderboard.you": "ترتيبك",
  "leaderboard.who": "من يُحتسب",
  "leaderboard.scope.all": "الجميع",
  "leaderboard.scope.guild": "سيرفري",
  "leaderboard.emptyGuild":
    "لا أحد من سيرفرك في الترتيب بعد. تُحتسب طاولات اللاعبين الأربعة فقط، لا المباريات مع البوتات.",
  "leaderboard.unranked": "غير مصنف بعد: العب طاولة من أربعة لاعبين",
  "leaderboard.empty":
    "لا توجد مباريات مصنفة بعد. تُحتسب طاولات اللاعبين الأربعة فقط، لا المباريات مع البوتات.",
  "leaderboard.loading": "جارٍ تحميل الترتيب…",
  "leaderboard.error": "لم يتم تحميل الترتيب.",
  "leaderboard.retry": "حاول مرة أخرى",
  "leaderboard.trend.new": "جديد",
  "leaderboard.trend.up": "صعود {n}",
  "leaderboard.trend.down": "نزول {n}",
  "leaderboard.trend.same": "بدون تغيير",
};
